// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Download02Icon } from '@metarouter-private/mr-mui';

export default function BulkOperationModalActions({
  isIdle,
  isProcessing,
  isComplete,
  canUpload,
  onCancel,
  onUpload,
  onClose,
  onDownloadReport,
  uploadButtonTestId,
  downloadButtonTestId,
  closeButtonTestId,
}) {
  if (isIdle) {
    return (
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button color="secondary" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onUpload} disabled={!canUpload} data-test-id={uploadButtonTestId}>
          Upload
        </Button>
      </Stack>
    );
  }

  if (isProcessing) {
    return (
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button variant="outlined" disabled>
          Cancel
        </Button>
        <Button variant="contained" disabled>
          Processing...
        </Button>
      </Stack>
    );
  }

  if (isComplete) {
    return (
      <Stack direction="row" spacing={1}>
        <Button onClick={onClose} color="secondary" variant="outlined" data-test-id={closeButtonTestId}>
          Close
        </Button>
        <Button
          onClick={onDownloadReport}
          variant="contained"
          startIcon={<Download02Icon />}
          data-test-id={downloadButtonTestId}
        >
          Download Report
        </Button>
      </Stack>
    );
  }

  return null;
}

BulkOperationModalActions.propTypes = {
  isIdle: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  canUpload: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownloadReport: PropTypes.func.isRequired,
  uploadButtonTestId: PropTypes.string,
  downloadButtonTestId: PropTypes.string,
  closeButtonTestId: PropTypes.string,
};
